/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.24.0
 */

import { TableFilterPresetQueryId } from '@/main/components/Table/types/tableTypes';
import { RoutePath } from '@/main/routes/constants/routesConstants';

export enum ENotificationsFeedbackCode {
    TARGET_ACTION_EXECUTED = 'TARGET_ACTION_EXECUTED'
}

export enum ENotificationBannerType {
    PERSONAL_DATA_CONFIRMATION_ACCOUNTS = 'PERSONAL_DATA_CONFIRMATION_ACCOUNTS',
    PERSONAL_DATA_CONFIRMATION_SUBSCRIBERS = 'PERSONAL_DATA_CONFIRMATION_SUBSCRIBERS',
    AUTH = 'AUTH',
    UNPAID_BILLS = 'UNPAID_BILLS',
    DEFAULT = 'DEFAULT',
    OUTSTANDING_DEBT = 'OUTSTANDING_DEBT',
}
export enum ENotificationBannerId {
    PERSONAL_DATA_CONFIRMATION_ACCOUNTS = -1,
    PERSONAL_DATA_CONFIRMATION_SUBSCRIBERS = -2,
    AUTH = -3,
    UNPAID_BILLS = -4,
    DEFAULT = -5,
}

export enum ENotificationItemSeverity {
    DANGER = 'DANGER',
    INFO = 'INFO',
    WARNING = 'WARNING',
    SUCCESS = 'SUCCESS',
    CVM = 'CVM',
}

export enum ENotificationsItemType {
    NOTIFICATION_ORDERS = 'NOTIFICATION_ORDERS',
    NOTIFICATION_INQUIRIES = 'NOTIFICATION_INQUIRIES',
    NOTIFICATION_NEWS = 'NOTIFICATION_NEWS',
    NOTIFICATION_BANNER = 'NOTIFICATION_BANNER',
    NOTIFICATION_EDM = 'NOTIFICATION_EDM',
    NOTIFICATION_CVM = 'NOTIFICATION_CVM',
    NOTIFICATION_CASHBACK = 'NOTIFICATION_CASHBACK',
}
export enum ENotificationUpdateStatus {
    UNVIEWED = 'UNVIEWED',
    VIEWED = 'VIEWED',
}

export enum ENotificationsSettingsFields {
    showNotifications = 'showNotifications',
    showNews = 'showNews',
    showNotificationsOrders = 'showNotificationsOrders',
    showNotificationsInquiries = 'showNotificationsInquiries',
    showNotificationsEdo = 'showNotificationsEdo',
    showNotificationsCashback = 'showNotificationsCashback',
}

export const GROUP_OVERFLOW_LIMIT = 100;

export const NOTIFICATIONS_INQUIRIES_FILTER_ID = 'inquiries-group-with-notifications';

export const NOTIFICATIONS_PERSONAL_DATA_NOT_CONFIRMED_FILTER_ID = 'personal_data_not_confirmed';

export const NOTIFICATIONS_FILTRED_INQUIRIES_LINK = `${RoutePath.inquiries}?${TableFilterPresetQueryId}=${NOTIFICATIONS_INQUIRIES_FILTER_ID}`;

export const NOTIFICATIONS_FILTRED_ACCOUNTS_PERSONAL_DATA_LINK = `${RoutePath.account}?${TableFilterPresetQueryId}=${NOTIFICATIONS_PERSONAL_DATA_NOT_CONFIRMED_FILTER_ID}`;

export const NOTIFICATIONS_FILTRED_SUBSCRIBERS_PERSONAL_DATA_LINK = `${RoutePath.subscriberMobile}?${TableFilterPresetQueryId}=${NOTIFICATIONS_PERSONAL_DATA_NOT_CONFIRMED_FILTER_ID}`;
